var React = require('react');

function Flag (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"flag","transform":"translate(-0.001)"},React.createElement("path",{"id":"Shape","d":"M3.063,24H.553a.554.554,0,0,1,0-1.107h.7V2.534a1.328,1.328,0,1,1,1.107,0v.706H15.851a.553.553,0,0,1,.444.885l-3.133,4.2,3.113,4.181a.553.553,0,0,1-.444.884H2.362v9.5h.7a.554.554,0,0,1,0,1.107Zm-.7-13.556v1.839H14.729l-2.7-3.628a.558.558,0,0,1,0-.662l2.721-3.648H2.362V6.184H5.121a.553.553,0,1,1,0,1.107H2.362V9.338H4.125a.553.553,0,1,1,0,1.106ZM1.808,1a.331.331,0,1,0,.331.331A.332.332,0,0,0,1.808,1Z","transform":"translate(0.001)","fill":"#DE375C"})));
}

Flag.defaultProps = {"width":"16.405","height":"24","viewBox":"0 0 16.405 24"};

module.exports = Flag;

Flag.default = Flag;
